import api from '../../plugins/api';

/**
 * POST /crm/cars/createConsignment â Ð¿ÑÐ¸Ð²ÑÐ·ÑÐ²Ð°ÐµÑ Ðº ÑÐ¶Ðµ ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ð¼Ñ Ð°Ð²ÑÐ¾ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°
 * (ÐºÐ»Ð¸ÐµÐ½ÑÐ° CRM), ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐÐ¦ Ð¸ ÑÑÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°. ÐÐ¾ÑÐ»Ðµ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÑÐ°Ð·Ñ
 * Ð¿ÐµÑÐµÑÐ¾Ð´Ð¸Ñ Ðº ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ ÑÐ´ÐµÐ»ÐºÐ¸.
 *
 * @param {Object} params
 * @param {number} params.carId
 * @param {number} params.sellerClientId â id ÐºÐ»Ð¸ÐµÐ½ÑÐ°-Ð´Ð¾Ð²ÐµÑÐ¸ÑÐµÐ»Ñ
 * @param {number} params.price â ÑÐµÐ½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ
 * @param {Object} params.requisites â ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐÐ¦ (Ð¿Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾Ð³Ð¾)
 * @param {Object} params.sellerRequisites â ÑÑÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°: recipient, iban, bankName, bic
 * @returns {Promise<{ data: { consignmentId: number } }>}
 */
const createConsignment = (params) => {
  return api.post('/api/crm/cars/createConsignment', params);
};

export default createConsignment;
